import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'

const CourseCard = ({ course }) => {
  const { user } = useContext(AuthContext)
  const isInstructor = user?.id === course.instructor.id

  return (
    <div className='bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300'>
      {course.thumbnail ? (
        <img
          src={course.thumbnail}
          alt={course.title}
          className='w-full h-48 object-cover'
        />
      ) : (
        <div className='w-full h-48 bg-gradient-to-r from-primary-500 to-primary-600 flex items-center justify-center'>
          <span className='text-white text-4xl font-bold'>
            {course.title.charAt(0)}
          </span>
        </div>
      )}
      <div className='p-6'>
        <h3 className='text-xl font-semibold text-gray-900 mb-2'>
          {course.title}
        </h3>
        <p className='text-gray-600 mb-4 line-clamp-2'>{course.description}</p>
        <div className='flex items-center justify-between mb-4'>
          <span className='text-sm text-gray-500'>
            {course.total_lessons} lessons
          </span>
          <span className='text-sm text-gray-500'>
            {course.total_duration} min
          </span>
        </div>
        <div className='flex items-center justify-between'>
          <span className='text-sm text-gray-700'>
            By {course.instructor.first_name} {course.instructor.last_name}
          </span>
          <div className='flex space-x-2'>
            <Link
              to={`/courses/${course.id}`}
              className='bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-700'
            >
              View Course
            </Link>
            {isInstructor && (
              <Link
                to={`/courses/${course.id}/manage`}
                className='bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-green-700'
              >
                Manage
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseCard
